/**
 * @desc 加油橇对账Details分页接口
 */

import fetch from '@/utils/request'
import config from '@/config'

export interface QueryParams {}

export function request(data: defs.PageRequest<defs.ComeOnReconciliationQueryParameters>): Promise<BaseResponse<defs.PageBean<Array<defs.TheReconciliationSubsidiaryEntities>>>> {
  return fetch({
    url: config.API_HOST + '/fuel/fee/refuelingSkidReconciliationDetailPageList',
    data: data,
    method: 'POST',
    credentials: 'include',
    timeout: 20 * 1000,
  })
}
